let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gyqsg")).then(() => parcelRequire('j8IiS'));